import { RootState } from '@/redux/rootStore';

export const selectAppJwt = (state: RootState): string => state.auth.jwt;
export const selectAuthExp = (state: RootState): number => state.auth.exp;
export const getFirstLogin = (state: RootState): boolean => state.auth.firstLogin;
export const selectIsLogOut = (state: RootState): boolean => state.auth.isLogOut;
export const selectIsAuthenticated = (state: RootState): boolean => state.auth.isAuthenticated;
